/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to discover Azure AD tenant ID from domain
 * @export
 * @interface AzureTenantDiscoveryRequest
 */
export interface AzureTenantDiscoveryRequest {
    /**
     * Domain name to discover Azure tenant for
     * @type {string}
     * @memberof AzureTenantDiscoveryRequest
     */
    domain: string;
}

/**
 * Check if a given object implements the AzureTenantDiscoveryRequest interface.
 */
export function instanceOfAzureTenantDiscoveryRequest(value: object): value is AzureTenantDiscoveryRequest {
    if (!('domain' in value) || value['domain'] === undefined) return false;
    return true;
}

export function AzureTenantDiscoveryRequestFromJSON(json: any): AzureTenantDiscoveryRequest {
    return AzureTenantDiscoveryRequestFromJSONTyped(json, false);
}

export function AzureTenantDiscoveryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AzureTenantDiscoveryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'domain': json['domain'],
    };
}

export function AzureTenantDiscoveryRequestToJSON(json: any): AzureTenantDiscoveryRequest {
    return AzureTenantDiscoveryRequestToJSONTyped(json, false);
}

export function AzureTenantDiscoveryRequestToJSONTyped(value?: AzureTenantDiscoveryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'domain': value['domain'],
    };
}

